import { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom"
import { AppMenuEvents } from "../../events/app-menu";
import { EventNotificationService } from "../../framework/services/event-notification";
import { AppRoutes, getAppRouteByPathname } from "../app-routes";
import { AdminSignInService } from "../../services/admin-signin";

export const usePageManager = () => {
    const location = useLocation();
    const history = useHistory();

    useEffect(() => {
        const currentRoute = getAppRouteByPathname(location.pathname);

        // if the current route is known and requires sign in,
        // and the user is not signed in, force the user to go to the sign in page
        if(!!currentRoute && currentRoute.allowAnonymous === false
            && AdminSignInService.isAuthenticated() === false) {
                history.push(AppRoutes.signIn.url());
        }
        // if the current route is the sign in page, and the user is signed in,
        // force user to go to the projects page
        else if(!!currentRoute && currentRoute.key === AppRoutes.signIn.key
            && AdminSignInService.isAuthenticated()) {
                history.push(AppRoutes.home.url());
        }

        if(currentRoute?.sideMenuSupported) {
            EventNotificationService.dispatch(AppMenuEvents.MenuAvailable);
        } else {
            EventNotificationService.dispatch(AppMenuEvents.MenuUnavailable);
        }
    }, [location, history]);
}